import React, { useEffect, useReducer, useState} from 'react';
import {Container, Row,Button, Nav, Accordion} from 'react-bootstrap'
import { Link } from 'react-router-dom';

import $ from 'jquery'
import jQuery from 'jquery'
import "../stylesheets/style.css"
import "../stylesheets/navbar.css"
import "../js/main.js"

import Navbar from './Navbar';
import TopBar from "./TopBar"
import BookOptions from './BookOptions';

const BookAnApartment = () => {
    useEffect(() =>{
        document.title = "Home | Earth VIII Apartments"
    },[])

   
    useEffect(() =>{
   
        // var usertoken = localStorage.getItem("access_token")
        // if(usertoken ===null){
        //               window.location.replace("/signin");
  
        //             }
            
     
                  var settingstwo = {
                    beforeSend: function(){
      $('.loading').css("visibility", "visible");
    },
    "url": "https://api.lodgify.com/v1/properties",
                        "method": "GET",
                        "timeout": 0,
                        "headers": { "X-ApiKey": "SfeILETE0TcCFOziCtTXBPxfqsmTR6aO5F+3cJRmobMf/w8HEVw7xqAvAyNPlD0O"},
                        complete: function(){
      $('.loading').css("visibility", "hidden");
    }
                    }
             
            
                    $.ajax(settingstwo).done(function (responsetwo) {
                    
                      $.each(responsetwo, function (i, item) {
                        console.log(responsetwo[i].id)
              
                          var settingsthree = {
                         "url": "https://api.lodgify.com/v1/properties/" + responsetwo[i].id,
                        "method": "GET",
                        "timeout": 0,
                        "headers": { "Authorization": "Bearer " +  localStorage.getItem("access_token")},
                    }
                    $.ajax(settingsthree).done(function (responsethree) {
                        console.log(responsethree)
                    
                          $('#musicbox3').append(
                            jQuery.trim(
                                
                         `<div class="musicitem">

                         <div class="row">
                      
                             <div class="col-md-6">
                              <img class='musicimage' src="${responsethree.image_url }"/>
                             </div>

                             

                             <div class="col-md-6">
                             <p class="textfont moodtitle"> ${responsethree.name}</p>
                             <p class="textfont moodtitle"><span className=""> ${responsethree.name}</span></p>
                             </div>
                             </div>



                           
               
                            
                            </div>`
                       
                          
                          
                          ));
      
                    })

                 }) })

                 })



    return (



<div class="wrapper">
<Navbar/>
<div id="content">

<TopBar/>
<BookOptions/>
    
<br/>
<br/>

<h4 className="avapttitle">Available Apartments</h4>


<div id='musicbox3'>

</div>






<br/>
<br/>

  </div>   

</div>


  
    )


}


export {BookAnApartment as default}